import { NavigateFunction } from 'react-router';

import { navigateToFrame } from 'components/Header/components/SearchBar/utils/navigateToFrame';
import { Frame } from 'features/Frames/types';
import { SEARCH_PAGE_URL } from 'utils/defaults';

export const handleShowAllSearchResults = (
  navigate: NavigateFunction,
  inputValue: string,
  searchResults: Frame[]
) => {
  if (inputValue === '') {
    return;
  }
  if (searchResults.length === 0) {
    return;
  }
  if (searchResults.length === 1) {
    navigateToFrame(navigate, searchResults[0].id);
    return;
  }
  navigate(`${SEARCH_PAGE_URL}?searchTerm=${inputValue}`);
};
